<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn readonly text fab v-on="on" v-bind="attrs">
            <v-icon color="blue">mdi-lock-open</v-icon></v-btn>
      </template>
      <span>
        El responsable del tratamiento de sus datos personales es la Fundación PC SHEK Colombia , identificado con Nit: 900598301-3, con sede principal en Autopista Medellín KM 3.5 - Costado sur Vía Siberia, Terminal Terrestre de Carga de Bogotá.
        En cumplimiento de la Ley 1581 de 2012 , de Protección de Datos Personales , la información recopilada en este portal web será gestionada con la finalidad de hacer más ágil la comunicación con nuestros clientes, proveedores y aliados, por lo anterior toda la información será tratada con la máxima confidencialidad según las leyes vigentes.
        La autorización para el tratamiento de sus datos personales, nos permite, recolectar, transferir, cargar, usar, circular, suprimir, compartir, actualizar y transmitir información relevante a los servicios, pagos y trámites.
      </span>
    </v-tooltip>
  </div>
</template>
<script>
export default {};
</script>